<template>
  <div>
    <v-container>
      <h1 class="text-md-center green-security">{{ menu.title }}</h1>
      <drop-down-list :menus="menu.menus_dropdown" v-if="menu.menus_dropdown.length" />
      <internal-menus-list :menus="menu.menus" :title="menu.title" v-if="menu.menus.length" />
    </v-container>
  </div>
</template>

<script>
import DropDownList from "./DropDownList";
import InternalMenusList from "./InternalMenusList";
export default {
  components: {
    DropDownList,
    InternalMenusList
  },
  props: {
    menu: {
      type: Object,
      required: true
    }
  }
};
</script>